import React from "react";
import Space from "components/common/space";
import T from "@marginly/ui/components/typography";
import * as S from "./styled";
import { formatNum } from "util/format";
import { MemberScore } from "types/api";
interface Props {
  topRank: number;
  getPrizeNumber: (
    placeNumber: number | null | undefined,
  ) => number | undefined;
  getReferralPrizeNumber: (
    placeNumber: number | null | undefined,
  ) => number | undefined;
  badges: {
    position: string;
    prize: number;
    src: string;
  }[];
  referBadges: {
    position: string;
    prize: number;
    src: string;
  }[];
  getRefRankImg: (placeNumber: number | undefined | null) => string;
  getRankImg: (placeNumber: number | undefined | null) => string;
  memberPlacement: MemberScore | undefined;
  rank: number | null | undefined;
  tradeLink?: React.ReactNode;
  userReferralPlace: number | null | undefined;
  renderInfo: (prizeSum: number) => React.ReactNode;
}

export function RankInfo({
  topRank,
  userReferralPlace,
  getPrizeNumber,
  getReferralPrizeNumber,
  badges,
  referBadges,
  getRefRankImg,
  getRankImg,
  memberPlacement,
  rank,
  tradeLink,
  renderInfo,
}: Props) {
  const isWinRank = (rank || Infinity) <= topRank;
  const isWinReferral = (userReferralPlace || Infinity) < 11;

  const getPrizeSum = () => {
    const prizeNumber = getPrizeNumber(rank);
    const rankPrize =
      isWinRank && prizeNumber ? badges[prizeNumber - 1].prize : 0;
    const referalNumber = getReferralPrizeNumber(userReferralPlace);
    const referalPrize =
      isWinReferral && referalNumber ? referBadges[referalNumber - 1].prize : 0;
    return rankPrize + referalPrize;
  };

  const isPositivePnl = (memberPlacement?.score || 0) >= 0;
  const prizeSum = getPrizeSum();

  const getPrizeImg = () => {
    const refRankImg = getRefRankImg(userReferralPlace);
    if (isWinRank) {
      return (
        <S.PlacePicContainer>
          <S.PlacePic src={getRankImg(rank)} alt="" className="place-pic" />
          {isWinReferral ? (
            <S.PlaceAbsolutePic src={refRankImg} alt="" />
          ) : null}
          <Space height={40} heightMobile={40} />
        </S.PlacePicContainer>
      );
    }
    if (isWinReferral) {
      return (
        <S.PlacePicContainer>
          <S.PlacePic src={refRankImg} alt="" />
          <Space height={40} heightMobile={40} />
        </S.PlacePicContainer>
      );
    }
    return null;
  };

  return (
    <div>
      {getPrizeImg()}
      {renderInfo(prizeSum)}
      <Space height={32} heightMobile={34} />

      <S.PnL className={isPositivePnl ? "" : "negative"}>
        <T body>
          {isPositivePnl ? "+" : ""}${formatNum(memberPlacement?.score)}
        </T>
      </S.PnL>

      <Space height={50} heightMobile={48} />
      {tradeLink}
    </div>
  );
}
